const DishPrice = [
  { id: 20, price: 20 },
  { id: 30, price: 30 },
  { id: 40, price: 40 },
  { id: 60, price: 60 },
  { id: 80, price: 80 },
  { id: 100, price: 100 },
  { id: 120, price: 120 },
  { id: 160, price: 160 },
];

export default DishPrice;
